import { render } from "./LoginSetup.vue?vue&type=template&id=b610ed8c"
import script from "./LoginSetup.vue?vue&type=script&lang=js"
export * from "./LoginSetup.vue?vue&type=script&lang=js"

import "./LoginSetup.vue?vue&type=style&index=0&id=b610ed8c&lang=css"

import exportComponent from "C:\\Users\\pawarawat\\Documents\\Vue\\WebServer_Vue_NameCardSouvenir\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__